import React from 'react'
import { cloneDeep } from 'lodash'
import { Tabs, Row, Col, Radio, Tooltip } from 'antd'
import { getMenuSelect } from 'helpers/format'
import { CreateReq } from 'Store/product/types'
import { AppInput, AppSelect, AppTextArea } from 'Components/form'
import AppCategory from 'Components/form/AppCategory'
import { Data as CateData } from 'Store/categories/types'
import { Data as UomData } from 'Store/uom/types'
import { Data as ManufactuerData } from 'Store/manufactuer/types'
import { menuProductMaterialType } from 'helpers/constanst'
import { getStaffPermission } from 'helpers/account'
import { InfoCircleOutlined, InfoCircleTwoTone } from '@ant-design/icons'
import theme, { MyTheme } from 'Components/common/Theme'
import styled from 'styled-components'
const { TabPane } = Tabs

type Props = {
  formData: CreateReq
  onUpdateData: (val: any, key: string) => void
  setFormData: (formData: CreateReq) => void
  categories: CateData[]
  uoms: UomData[]
  manufacturers: ManufactuerData[]
  isError: (name: string) => boolean
  isRequired: (name: string) => boolean
  isDisabled: (name: string) => boolean
  isCreateMode: boolean
  isPackageC: boolean
}

const ProductInfo: React.FunctionComponent<Props> = props => {
  const {
    formData,
    onUpdateData,
    categories,
    uoms,
    manufacturers,
    isError,
    isRequired,
    setFormData,
    isDisabled,
    isCreateMode,
    isPackageC,
  } = props

  const permission = getStaffPermission()
  const hasManageBomPermission = permission && permission.includes('manage-bom')

  const onChangeCategories = (value: any) => {
    const data = cloneDeep(formData) as CreateReq
    data['group_id'] = value[0] ? value[0] : 0
    data['category_id'] = value[1] ? value[1] : 0
    data['sub_category_id'] = value[2] ? value[2] : 0
    setFormData({ ...data })
  }

  const renderTooltip = (title: any) => {
    return (
      <StockWrapper>
        <Tooltip title={title} placement="right">
          {' '}
          <InfoCircleOutlined />
        </Tooltip>
      </StockWrapper>
    )
  }

  const getCategoriesValue = () => {
    const value = []
    if (formData?.group_id) {
      value.push(formData?.group_id)
    }
    if (formData?.category_id) {
      value.push(formData?.category_id)
    }
    if (formData?.sub_category_id) {
      value.push(formData?.sub_category_id)
    }
    return value
  }

  const ProductInfoForm = (
    <Row justify="space-between" gutter={16}>
      <Col md={12} xs={24}>
        <AppInput
          name="title"
          label="ชื่อสินค้า"
          isRequired={isRequired('title')}
          isError={isError('title')}
          value={formData.title}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('title') }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="code"
          label="รหัสสินค้า"
          isRequired={isRequired('code')}
          isError={isError('code')}
          value={formData.code}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('code') }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppCategory
          label="หมวดหมู่สินค้า"
          isRequired={isRequired('group_id')}
          isError={isError('group_id') || isError('category_id') || isError('sub_category_id')}
          categories={categories}
          name="group_id"
          onChange={onChangeCategories}
          value={getCategoriesValue()}
          readonly={isDisabled('group_id')}
          changeOnSelect={false}
          allowClear={false}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppSelect
          name="manufacturer_id"
          label="ยี่ห้อ"
          isRequired={isRequired('manufacturer_id')}
          isError={isError('manufacturer_id')}
          value={formData?.manufacturer_id || 0}
          onChange={onUpdateData}
          menu={getMenuSelect(manufacturers)}
          disabled={isDisabled('manufacturer_id')}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="model"
          label="รุ่น"
          isRequired={isRequired('model')}
          isError={isError('model')}
          value={formData.model}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('model') }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppSelect
          name="uom_id"
          label={isPackageC ? 'หน่วยสินค้าหลัก' : 'หน่วยสินค้า'}
          isRequired={isRequired('uom_id')}
          isError={isError('uom_id')}
          value={formData?.uom_id || 0}
          onChange={onUpdateData}
          menu={getMenuSelect(uoms)}
          disabled={isDisabled('uom_id')}
          labelIcon={
            isPackageC
              ? renderTooltip(
                  <TextRemark>
                    หากต้องการขายสินค้าแบบหลายหน่วยนับ
                    เราแนะนำให้คุณตั้งหน่วยหลักเป็นหน่วยที่เล็กที่สุดที่คุณใช้ติดตามสต็อก
                  </TextRemark>,
                )
              : null
          }
        />
      </Col>
      {isCreateMode && isPackageC && hasManageBomPermission && (
        <Col md={12} xs={24}>
          <AppSelect
            name="bom"
            label="ประเภทสินค้า (ไม่สามารถแก้ไขภายหลังได้)"
            isRequired={isRequired('bom')}
            isError={isError('bom')}
            value={formData.bom}
            onChange={onUpdateData}
            menu={menuProductMaterialType}
            allowClear={false}
          />
          {/* <span>ประเภทสินค้า</span> &nbsp;
        <Radio.Group value={formData.bom} onChange={e => onUpdateData(e.target.value, 'bom')}>
          <Radio.Button value={0}>สินค้าไม่มีส่วนประกอบ</Radio.Button>
          <Radio.Button value={1}>สินค้ามีส่วนประกอบ</Radio.Button>
        </Radio.Group> */}
        </Col>
      )}
      <Col md={24} xs={24}>
        <AppTextArea
          label="รายละเอียดสินค้า"
          isRequired={isRequired('details')}
          isError={isError('details')}
          name="details"
          rows={2}
          value={formData.details}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('details') }}
        />
      </Col>
    </Row>
  )

  const ProductInfoOther = (
    <Row justify="space-between" gutter={16}>
      <Col md={24} xs={24}>
        <AppTextArea
          label="วิธีการใช้งาน"
          isRequired={isRequired('manual')}
          isError={isError('manual')}
          name="manual"
          rows={3}
          value={formData.manual}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('manual') }}
        />
      </Col>
      <Col md={24} xs={24}>
        <AppTextArea
          label="การบำรุงรักษาและข้อควรระวัง"
          isRequired={isRequired('maintenant_and_caution')}
          isError={isError('maintenant_and_caution')}
          name="maintenant_and_caution"
          rows={3}
          value={formData.maintenant_and_caution}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('maintenant_and_caution') }}
        />
      </Col>
      <Col md={24} xs={24}>
        <AppTextArea
          label="คุณสมบัติสินค้า"
          isRequired={isRequired('properties')}
          isError={isError('properties')}
          name="properties"
          rows={3}
          value={formData.properties}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('properties') }}
        />
      </Col>
    </Row>
  )

  return (
    <Tabs defaultActiveKey="1" tabPosition="top">
      <TabPane tab="ข้อมูลทั่วไป" key="1">
        {ProductInfoForm}
      </TabPane>
      <TabPane tab="ข้อมูลอื่นๆ" key="2">
        {ProductInfoOther}
      </TabPane>
    </Tabs>
  )
}

const StockWrapper = styled.span`
  padding: 0 2px;
`

const TextRemark = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

export default ProductInfo
